<div class="modal active shortcuts-management">
  <div class="modal__container">
      <div class="fields">
          <h2>Shortcuts Management</h2>
          <div class="close" (click)="cancel()"><img src="/assets/img/close-white.svg" alt="" /></div>
          <div class="text">Please select the shortcut that you want to create:</div>
          <div class="fields__container" style="border: none;">
            <div *ngFor="let shortcut of this.shortcuts" [ngClass]="shortcut.selected? 'selected' : ''" (click)="selectItem(shortcut)">
              <a>{{ shortcut.name}}</a>
            </div>
          </div>
          <div class="fields__btn">
            <button type="submit" class="blue" (click)="save()" >Save</button>
            <a href="" type="reset" class="gray">Cancel</a>
          </div>
      </div>
  </div>
</div>
